<rpfsa-user-header headerText="RAILS Users"> </rpfsa-user-header>
<mat-card>
	<div fxLayout>
		<div [formGroup]="filters">
		<mat-form-field fxFlex="300px">
			<input
				matInput
				formControlName="searchText"
				(keyup)="applyFilter($event.target.value)"
				placeholder="Search"
				autocomplete="off"
			/>
			<mat-icon matSuffix>search</mat-icon>
		</mat-form-field>
		</div>
	</div>

	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th
				mat-header-cell
				*matHeaderCellDef
				[colSpan]="resultColumns.length"
				class="text-center"
			>
				<div *ngIf="isLoading$ | async" class="list-loader">
					<mat-progress-bar mode="indeterminate"></mat-progress-bar>
				</div>
				<em> {{ listMessage$ | async }}</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="lastName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let user">
				<a [routerLink]="usersFragments.adminUserDetail(user.id)">
					{{ user.firstName }} {{ user.lastName }}
				</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
			<td mat-cell *matCellDef="let user">{{ user.email }}</td>
		</ng-container>
		<ng-container matColumnDef="employee">
			<th mat-header-cell *matHeaderCellDef>Personnel Link</th>
			<td mat-cell *matCellDef="let user">
				<a
					[routerLink]="
						personnelFragments.detail(user.fieldWorker.id)
					"
					*ngIf="user.fieldWorker"
				>
					{{ user.fieldWorker.firstName }}
					{{ user.fieldWorker.lastName }}
				</a>
				<small *ngIf="!user.fieldWorker">
					<em>Not linked</em>
				</small>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="listMessage$ | async"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="!(listMessage$ | async)"
		></tr>
		<tr
			mat-row
			*matRowDef="let user; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator> </mat-paginator>
	</div>
</mat-card>
